import { render } from "./WarehouseDatatableTDKitTitle.vue?vue&type=template&id=8c9a7c5a"
import script from "./WarehouseDatatableTDKitTitle.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableTDKitTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__